module.exports = __webpack_public_path__ + "static/assets/49bbae1fee42bd613c85d54d65bf045a.png";